import { createFileRoute } from '@tanstack/react-router'
import { Synced } from '../../mud/Synced'
import { useGetUnlinkedBatches } from '../../api/get-batches'
import { useBatchActions } from '../../hooks/use-batch-actions'
import { useRole } from '../../context/role'
import { DppPanel } from '../../ui/dpp-panel'
import { BatchesTable } from '../../ui/batches-table'

const Index = () => {
  const { config } = useRole()
  const stashBatches = useGetUnlinkedBatches()
  const { unlinked, selected, setSelected, deletingKey, isRemoving, handleSelect, handleDelete } = useBatchActions(stashBatches)


  return (
    <div className="p-4 sm:p-8 max-w-5xl mx-auto">
      <Synced
        fallback={({ message, percentage }) => (
          <div className="tabular-nums text-center mt-20 text-warm-500">
            {message} ({percentage.toFixed(1)}%)…
          </div>
        )}
      >
        <div className="flex items-center justify-between gap-3 mb-5 sm:mb-6">
          <h1 className="font-display text-xl sm:text-3xl font-bold text-warm-900 leading-tight">Logistics DPP Platform</h1>
        </div>

        {unlinked.length === 0 ? (
          <p className="text-warm-500 text-sm">No unlinked batches found.</p>
        ) : (
          <BatchesTable
            batches={unlinked}
            selected={selected}
            deletingKey={deletingKey}
            isRemoving={isRemoving}
            canDelete={config.canDelete}
            onSelect={handleSelect}
            onDelete={handleDelete}
          />
        )}

        {selected && (
          <DppPanel
            gtin={selected.gtin}
            batchUuid={selected.batchUuid}
            onClose={() => setSelected(null)}
          />
        )}
      </Synced>
    </div>
  )
}

export const Route = createFileRoute('/_app/')({
  component: Index,
})
